import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store/index";
import Main from "../views/Main.vue";
import Dashboard from "../components/dashboard/Dashboard.vue";
import Messages from "../components/messages/Messages.vue";
import Necesar from "../components/necesar/Necesar.vue";
import Login from "../components/auth/Login.vue";
import Logout from "../components/auth/Logout.vue";
import RaportIncasariPlati from "../components/rapoarteContabile/RaportIncasariPlati.vue";
import RaportIncasariCastiguri from "../components/rapoarteContabile/RaportIncasariCastiguri.vue";
import RaportNecesarNumerar from "../components/rapoarteContabile/RaportNecesarNumerar.vue";
import SituatiiContabile from "../components/rapoarteContabile/SituatiiContabile.vue";
import RegistruDeCasa from "../components/rapoarteContabile/RegistruDeCasa.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Main,
    children: [
        {
            path: "",
            name: "dashboard",
            component: Dashboard,
            meta: { requiresAuth: true }
        },
        {
            path: "messages",
            name: "messages",
            component: Messages,
            meta: { requiresAuth: true }
        },
        {
            path: "necesar",
            name: "necesar",
            component: Necesar,
            meta: { requiresAuth: true },
        },
        {
            path: "raport-incasari-plati",
            name: "raport-incasari-plati",
            component: RaportIncasariPlati,
        },
        {
            path: "raport-incasari-castiguri",
            name: "raport-incasari-castiguri",
            component: RaportIncasariCastiguri,
        },
        {
            path: "raport-necesar-numerar",
            name: "raport-necesar-numerar",
            component: RaportNecesarNumerar,
        },
        {
            path: "situatii-contabile",
            name: "situatii-contabile",
            component: SituatiiContabile,
        },
        {
            path: "registru-de-casa",
            name: "registru-de-casa",
            component: RegistruDeCasa,
        }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: { requiresAuth: true }
  }
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!Store.getters.loggedIn) {
            next({
            name: 'login',
            //query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        // this route requires guest, check if logged in
        // if yes, redirect to default (dashboard) page.
        if (Store.getters.loggedIn) {
            next({
                name: 'dashboard',
                //query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

export default router;
